import { Auth } from "aws-amplify";
import { IDTokenSupplier } from "./IDTokenSupplier";

export class AuthIDTokenSupplier implements IDTokenSupplier {
    public async get(): Promise<string> {
        const user = await Auth.currentAuthenticatedUser();
        return `prefix_${user.getSignInUserSession().getIdToken().getJwtToken()}`;
    }
}
